import React, { useState, useEffect } from 'react';
// import { useDemo } from '../../state/DemoContext'; // Unused import
import { formatCurrency, formatDate } from '../../utils/helpers';
import { getBorrowerData, getLoanOffers, getActiveLoans, acceptLoanOffer } from '../../utils/demoDataManager';
import './borrowerdashboard.css';

const BorrowerDashboard = () => {
  // const { state } = useDemo(); // Unused
  const [borrowerData, setBorrowerData] = useState(null);
  const [loanOffers, setLoanOffers] = useState([]);
  const [activeLoans, setActiveLoans] = useState([]);

  // Load data from cookies/defaults
  useEffect(() => {
    const borrower = getBorrowerData();
    const offers = getLoanOffers();
    const loans = getActiveLoans();
    
    setBorrowerData(borrower);
    setLoanOffers(offers);
    setActiveLoans(loans);
  }, []);

  if (!borrowerData) {
    return <div>Loading...</div>;
  }

  // Calculate metrics from actual data
  const totalLoansOutstanding = activeLoans.reduce((sum, loan) => sum + loan.amount, 0);
  const nextPaymentAmount = activeLoans.reduce((sum, loan) => sum + loan.nextPaymentAmount, 0);
  const numAssetsCollateralized = activeLoans.reduce((sum, loan) => sum + loan.collateralizedAssets.length, 0);
  const numAssetsUncollateralized = borrowerData.assets.length - numAssetsCollateralized;
  const totalOffersAvailable = loanOffers.reduce((sum, offer) => sum + offer.amount, 0);

  const handlePayNow = (loanId, amount) => {
    // Mock payment processing
    console.log(`Processing payment of ${formatCurrency(amount)} for loan ${loanId}`);
  };

  // eslint-disable-next-line no-unused-vars
  const handleAcceptOffer = (offerId) => {
    const newLoan = acceptLoanOffer(offerId);
    if (newLoan) {
      // Refresh data
      setLoanOffers(getLoanOffers());
      setActiveLoans(getActiveLoans());
    }
  };

  return (
    <div className="jo-xyz-demo-borrower-dashboard">
      <div className="jo-xyz-demo-borrower-dashboard__header">
        <h1>Borrower Dashboard</h1>
        <p>Manage your loans, track payments, and explore new financing opportunities</p>
      </div>

      {/* Key Metrics */}
      <div className="jo-xyz-demo-borrower-dashboard__metrics">
        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">💰</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{formatCurrency(totalLoansOutstanding)}</div>
            <div className="jo-xyz-demo-metric-card__label">Total Loans Outstanding</div>
          </div>
        </div>

        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">📅</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{formatCurrency(nextPaymentAmount)}</div>
            <div className="jo-xyz-demo-metric-card__label">Next Payment Amount</div>
          </div>
        </div>

        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">🏢</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{numAssetsCollateralized}</div>
            <div className="jo-xyz-demo-metric-card__label">Assets Collateralized</div>
          </div>
        </div>

        <div className="jo-xyz-demo-metric-card">
          <div className="jo-xyz-demo-metric-card__icon">📊</div>
          <div className="jo-xyz-demo-metric-card__content">
            <div className="jo-xyz-demo-metric-card__value">{numAssetsUncollateralized}</div>
            <div className="jo-xyz-demo-metric-card__label">Assets Uncollateralized</div>
          </div>
        </div>
      </div>

      {/* Current Loans */}
      <div className="jo-xyz-demo-borrower-dashboard__section">
        <h2>Current Loans</h2>
        <div className="jo-xyz-demo-loans-grid">
          {activeLoans.map((loan) => (
            <div key={loan.id} className="jo-xyz-demo-loan-card">
              <div className="jo-xyz-demo-loan-card__header">
                <div className="jo-xyz-demo-loan-card__amount">{formatCurrency(loan.amount)}</div>
                <div className="jo-xyz-demo-loan-card__status">{loan.status}</div>
              </div>

              <div className="jo-xyz-demo-loan-card__details">
                <div className="jo-xyz-demo-loan-detail">
                  <span className="jo-xyz-demo-loan-detail__label">Interest Rate:</span>
                  <span className="jo-xyz-demo-loan-detail__value">{loan.interestRate}%</span>
                </div>
                <div className="jo-xyz-demo-loan-detail">
                  <span className="jo-xyz-demo-loan-detail__label">Term:</span>
                  <span className="jo-xyz-demo-loan-detail__value">{loan.term}</span>
                </div>
                <div className="jo-xyz-demo-loan-detail">
                  <span className="jo-xyz-demo-loan-detail__label">Next Payment:</span>
                  <span className="jo-xyz-demo-loan-detail__value">{formatDate(loan.nextPaymentDate)}</span>
                </div>
                <div className="jo-xyz-demo-loan-detail">
                  <span className="jo-xyz-demo-loan-detail__label">Payment Amount:</span>
                  <span className="jo-xyz-demo-loan-detail__value">{formatCurrency(loan.nextPaymentAmount)}</span>
                </div>
                <div className="jo-xyz-demo-loan-detail">
                  <span className="jo-xyz-demo-loan-detail__label">Collateralized Assets:</span>
                  <span className="jo-xyz-demo-loan-detail__value">{loan.collateralizedAssets.length}</span>
                </div>
              </div>

              <div className="jo-xyz-demo-loan-card__actions">
                <button
                  className="jo-xyz-demo-btn jo-xyz-demo-btn--primary"
                  onClick={() => handlePayNow(loan.id, loan.payNowAmount)}
                >
                  Pay Now: {formatCurrency(loan.payNowAmount)}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Available Offers */}
      <div className="jo-xyz-demo-borrower-dashboard__section">
        <h2>Available Offers</h2>
        <div className="jo-xyz-demo-offers-summary">
          <div className="jo-xyz-demo-offers-summary__metric">
            <span className="jo-xyz-demo-offers-summary__value">{formatCurrency(totalOffersAvailable)}</span>
            <span className="jo-xyz-demo-offers-summary__label">Total Offers Available</span>
          </div>
          <div className="jo-xyz-demo-offers-summary__metric">
            <span className="jo-xyz-demo-offers-summary__value">{loanOffers.length}</span>
            <span className="jo-xyz-demo-offers-summary__label">Number of Offers</span>
          </div>
        </div>

        <div className="jo-xyz-demo-offers-grid">
          {loanOffers.map((offer) => (
            <div key={offer.id} className="jo-xyz-demo-offer-card">
              <div className="jo-xyz-demo-offer-card__header">
                <div className="jo-xyz-demo-offer-card__amount">{formatCurrency(offer.amount)}</div>
                <div className="jo-xyz-demo-offer-card__lender">{offer.lender}</div>
              </div>

              <div className="jo-xyz-demo-offer-card__details">
                <div className="jo-xyz-demo-offer-detail">
                  <span className="jo-xyz-demo-offer-detail__label">Interest Rate:</span>
                  <span className="jo-xyz-demo-offer-detail__value">{offer.interestRate}%</span>
                </div>
                <div className="jo-xyz-demo-offer-detail">
                  <span className="jo-xyz-demo-offer-detail__label">Term:</span>
                  <span className="jo-xyz-demo-offer-detail__value">{offer.term}</span>
                </div>
              </div>

              <div className="jo-xyz-demo-offer-card__actions">
                <button className="jo-xyz-demo-btn jo-xyz-demo-btn--secondary">View Details</button>
                <button className="jo-xyz-demo-btn jo-xyz-demo-btn--primary">Accept Offer</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BorrowerDashboard;
